import { render, staticRenderFns } from "./DappButtons.vue?vue&type=template&id=14a01cf3&scoped=true&"
import script from "./DappButtons.vue?vue&type=script&lang=js&"
export * from "./DappButtons.vue?vue&type=script&lang=js&"
import style0 from "./DappButtons.vue?vue&type=style&index=0&id=14a01cf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a01cf3",
  null
  
)

export default component.exports